"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@osmosys/utils");
exports.websiteLogger = utils_1.createOsmosysLogger({
    module: 'website',
});
//# sourceMappingURL=logger.js.map